import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { TypedMemo } from '../../common/types';
import { Cover } from '../../music24/components/primitives/Cover';
import { MeiliTrackData } from '../../music24/components/SearchField/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the sheet; each part uses its own slice of it */
import styles from './SMLCreationSheet.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CreationTrackRowProps {
  track: MeiliTrackData;
  onPick: (track: MeiliTrackData) => void;
}

/** One search hit out of our catalog. */
const CreationTrackRowComponent: React.FC<CreationTrackRowProps> = ({ track, onPick }) => {
  const pick = useCallback(() => onPick(track), [onPick, track]);

  return (
    <button type="button" className={styles.row} onClick={pick}>
      <Cover src={track.imageUrl} label={track.name} size={42} />
      <span className={styles.rowInfo}>
        <span className={styles.rowName}>{track.name}</span>
        <span className={styles.rowSub}>
          {track.albumName === undefined || track.albumName === ''
            ? track.artistName
            : `${track.artistName} · ${track.albumName}`}
        </span>
      </span>
      <FontAwesomeIcon icon={faChevronRight} className={styles.rowGo} />
    </button>
  );
};

export const CreationTrackRow = TypedMemo(CreationTrackRowComponent);
